import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
    LsqApiServiceListSource,
    SortDirectionFinancing
} from '@lsq-frontend/angular-shared/api-service';
import { AdminBuyersListDto } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/model/admin-buyers-list-dto';
import {
    AdminBuyersListRequest,
    ListBuyersService,
    ListResponseAdminBuyersListDto
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/operations/admin-buyers-list/list-buyers';
import {
    AdminBuyerImplementationsListRequest,
    ListBuyerImplementationsService,
    ListResponseAdminBuyerImplementationsListDto
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/operations/admin-buyer-implementations-list/list-buyer-implementations';
import { AdminBuyerImplementationsListDto } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/model/admin-buyer-implementations-list-dto';
import { SortDirection } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
@Injectable()
export class AdminBuyersService {
    public dataSource: LsqApiServiceListSource<
        ListResponseAdminBuyersListDto,
        AdminBuyersListRequest,
        AdminBuyersListDto
    >;

    public dataSourceBuyerImplementations: LsqApiServiceListSource<
        ListResponseAdminBuyerImplementationsListDto,
        AdminBuyerImplementationsListRequest,
        AdminBuyerImplementationsListDto
    >;

    public buyerFiltersFormGroup = new FormGroup({
        buyerPreferredName: new FormControl(),
        accountName: new FormControl()
    });

    public buyerImplementationsFiltersFormGroup = new FormGroup({
        buyerPreferredName: new FormControl(),
        accountName: new FormControl()
    });

    constructor(
        private _listBuyersService: ListBuyersService,
        private _listBuyerImplementationsService: ListBuyerImplementationsService,
        private _userService: UserService
    ) {
        this._userService.logout$.subscribe(() => {
            this.dataSource = null;
            this.dataSourceBuyerImplementations = null;
            this.buyerFiltersFormGroup.reset();
            this.buyerImplementationsFiltersFormGroup.reset();
        });
    }

    public initializeBuyersListSource(): void {
        if (this.dataSource) {
            this.dataSource.dispatchRequest();
        } else {
            this.dataSource = new LsqApiServiceListSource<
                ListResponseAdminBuyersListDto,
                AdminBuyersListRequest,
                AdminBuyersListDto
            >(this._listBuyersService, {
                pagination: {
                    take: 25,
                    skip: 0,
                    sortColumn: 'buyerPreferredName',
                    sortDirection: SortDirectionFinancing.ASCENDING
                }
            });
        }
    }

    public initializeBuyerImplementationsListSource(): void {
        if (this.dataSourceBuyerImplementations) {
            this.dataSourceBuyerImplementations.dispatchRequest();
        } else {
            this.dataSourceBuyerImplementations = new LsqApiServiceListSource<
                ListResponseAdminBuyerImplementationsListDto,
                AdminBuyerImplementationsListRequest,
                AdminBuyerImplementationsListDto
            >(this._listBuyerImplementationsService, {
                pagination: {
                    take: 25,
                    skip: 0,
                    sortColumn: 'buyerPreferredName',
                    sortDirection: SortDirectionFinancing.ASCENDING
                }
            });
        }
    }
}
